export enum FormSections {
  SOCIAL_LINKS = 'social_links',
  MY_PAGE_URL = 'my_page_url',
}
